define([], () => ({
  SHARE_RECEIVE_STATS: 'SHARE_RECEIVE_STATS',
  SHARE_RECEIVE_STATE: 'SHARE_RECEIVE_STATE',
  SHARE_UPDATE_SETTING: 'SHARE_UPDATE_SETTING',
  SHARE_RECEIVE_SETTINGS: 'SHARE_RECEIVE_SETTINGS',
  SHARE_RECEIVE_POSITION_SETTINGS: 'SHARE_RECEIVE_POSITION_SETTINGS',
  SHARE_RECEIVE_CUSTOM_POSITION_SETTINGS: 'SHARE_RECEIVE_CUSTOM_POSITION_SETTINGS',
  SHARE_RECEIVE_SHORTENER_STATE: 'SHARE_RECEIVE_SHORTENER_STATE',
}));
